var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaSolidStream(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.901786 11.7857H24.3482C24.8465 11.7857 25.25 11.3822 25.25 10.8839V7.27679C25.25 6.77855 24.8465 6.375 24.3482 6.375H0.901786C0.403549 6.375 0 6.77855 0 7.27679V10.8839C0 11.3822 0.403549 11.7857 0.901786 11.7857ZM27.9554 16.2946H4.50893C4.01069 16.2946 3.60714 16.6982 3.60714 17.1964V20.8036C3.60714 21.3018 4.01069 21.7054 4.50893 21.7054H27.9554C28.4536 21.7054 28.8571 21.3018 28.8571 20.8036V17.1964C28.8571 16.6982 28.4536 16.2946 27.9554 16.2946ZM24.3482 26.2143H0.901786C0.403549 26.2143 0 26.6178 0 27.1161V30.7232C0 31.2215 0.403549 31.625 0.901786 31.625H24.3482C24.8465 31.625 25.25 31.2215 25.25 30.7232V27.1161C25.25 26.6178 24.8465 26.2143 24.3482 26.2143Z",
    fill: "#004B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaSolidStream);
export default __webpack_public_path__ + "static/media/fa-solid_stream.88fd33f106607490663cb88a76c1100f.svg";
export { ForwardRef as ReactComponent };